import {
  NavigationGuard,
  Route,
  RouteRecord,
} from 'vue-router';
import {
  Store,
} from 'vuex';

import {
  NavigationGuardNext,
} from '@/store/types';

export const checkAuthorization = (
  store: Store<{}>,
): NavigationGuard => (to: Route, from: Route, next: NavigationGuardNext): void => {
  const isOnlyAuthPage = to.matched.some((_: RouteRecord) => _.meta.onlyAuth);
  const isAuthenticated = store.getters['auth/isAuthenticated'];

  if (isOnlyAuthPage && !isAuthenticated) {
    next({
      name: 'login',
      query: { redirect_to: to.fullPath },
    });
  } else {
    next();
  }
};
